// Central content for the Golden State Safety Certifications marketing site.

export const CONTACT = {
  phone: "(209) 570-9574",
  phoneRaw: "+12095709574",
  email: "contact@goldenstatesafety.net",
  domain: "goldenstatesafety.net",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/c0f5843e-6e9e-4214-8655-c09c85509bd1/images/7c0425c98fcc5660ca51de710d63ad33956ba6341594ed73c9b3cec76a3e9538.jpeg",
  forklift:
    "https://images.unsplash.com/photo-1740914994657-f1cdffdc418e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  aerial:
    "https://images.unsplash.com/photo-1774530758545-20168e8098ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  training:
    "https://images.unsplash.com/photo-1628147529780-36964fbb8d54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  safety:
    "https://images.unsplash.com/photo-1586528116022-aeda1613c63d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const MARQUEE = [
  "California OSHA Compliant",
  "222 Five-Star Reviews",
  "Onsite Training At Your Facility",
  "Photo Authorization ID Cards",
  "English & Spanish Instruction",
  "Troy Taylor — Lead Instructor",
  "All 7 Forklift Classifications",
];

export const STATS = [
  { value: "5.0", label: "Google Rating", suffix: "★" },
  { value: "222", label: "Verified Reviews", suffix: "+" },
  { value: "2.5", label: "Hour Onsite Class", suffix: "hr" },
  { value: "100", label: "Success Rate", suffix: "%" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Zero OSHA Fines",
    body: "Operator certification isn't optional — it's federal law. We keep your crew compliant and your business clear of penalties that can reach six figures per violation.",
  },
  {
    no: "02",
    title: "2.5-Hour Onsite Mastery",
    body: "We come to your facility and certify your team in about two and a half hours. No travel, no downtime, no production loss — training built around your schedule.",
  },
  {
    no: "03",
    title: "All 7 Classifications",
    body: "From electric rider trucks to rough-terrain forklifts and aerial lifts, we cover every OSHA class. One instructor, every piece of equipment you run.",
  },
  {
    no: "04",
    title: "Train-the-Trainer Ready",
    body: "Build your own in-house compliant program. Our certification kit equips your designated trainer to certify up to 20 operators — English and Spanish friendly.",
  },
];

export const SERVICES = [
  {
    id: "forklift",
    tag: "Program 01",
    title: "Forklift Operator Certification",
    image: IMAGES.forklift,
    desc: "OSHA-compliant certification on every type of powered industrial truck — offered onsite in English or Spanish.",
    points: [
      "Warehouse & Counterbalance",
      "Reach Truck & Order Picker",
      "Telehandler & Rough Terrain",
      "Pallet Jack & Walkie Stacker",
    ],
  },
  {
    id: "aerial",
    tag: "Program 02",
    title: "Aerial & Scissor Lift Certification",
    image: IMAGES.aerial,
    desc: "Convenient, cost-effective aerial lift safety programs meeting the highest Cal/OSHA compliance standards.",
    points: [
      "Scissor Lift Operation",
      "Boom & Articulating Lifts",
      "Fall Protection Protocols",
      "Jobsite Hazard Assessment",
    ],
  },
  {
    id: "trainer",
    tag: "Program 03",
    title: "Train-the-Trainer Certification",
    image: IMAGES.training,
    desc: "Develop a regulatory-compliant, in-house operator training program led by your own certified trainer.",
    points: [
      "Program Kit — 20 Certifications",
      "Spanish-Friendly Materials",
      "Certification Program $400",
      "Instructional Kit $600",
    ],
  },
];

export const COURSE_INCLUDES = [
  "Instructional safety driving skills",
  "Proper handling procedures",
  "Combo training — forklift & aerial",
  "Refueling & battery charging",
  "Daily equipment inspection",
  "Narrow aisle equipment",
];

export const BENEFITS = [
  "Required by OSHA regulations",
  "Avoid costly OSHA fines & penalties",
  "Boost productivity and profit",
  "Increase operator safety",
  "Reduce product & equipment damage",
  "Class instruction in ~2.5 hours",
];

export const CLASSIFICATIONS = [
  {
    cls: "Class I",
    name: "Electric Motor Rider Trucks",
    use: "Counterbalanced sit-down and stand-up riders used in loading docks and general warehousing.",
  },
  {
    cls: "Class II",
    name: "Electric Motor Narrow Aisle Trucks",
    use: "Reach trucks and order pickers designed for high-density, narrow-aisle storage.",
  },
  {
    cls: "Class III",
    name: "Electric Motor Hand Trucks",
    use: "Walkie stackers and electric pallet jacks for ground-level material movement.",
  },
  {
    cls: "Class IV",
    name: "Internal Combustion — Cushion Tire",
    use: "Sit-down cushion-tire trucks for smooth indoor surfaces and heavy loads.",
  },
  {
    cls: "Class V",
    name: "Internal Combustion — Pneumatic Tire",
    use: "Rugged pneumatic-tire trucks for outdoor yards and mixed terrain.",
  },
  {
    cls: "Class VI",
    name: "Electric & IC Engine Tractors",
    use: "Tow tractors used for pulling rather than lifting across large facilities.",
  },
  {
    cls: "Class VII",
    name: "Rough Terrain Forklift Trucks",
    use: "Heavy-duty telehandlers built for construction sites and uneven ground.",
  },
];

export const PRICING = [
  {
    tier: "1–5 Trainees",
    price: 225,
    popular: false,
    note: "Small crews & individuals",
  },
  {
    tier: "6–10 Trainees",
    price: 200,
    popular: true,
    note: "Growing teams",
  },
  {
    tier: "11+ Trainees",
    price: 175,
    popular: false,
    note: "Best value per operator",
  },
];

export const REVIEWS = [
  {
    name: "Christy Serrato",
    when: "3 months ago",
    text: "Troy was very responsive when I needed training scheduled right away. Scheduling training and certification was seamless. Would recommend to employers looking for a great onsite training and certification option for their equipment.",
  },
  {
    name: "Lacey Womble",
    when: "4 months ago",
    text: "Our owner and employees recently completed forklift training with Troy, and we couldn't be more impressed. From start to finish, everything was handled professionally and efficiently.",
  },
  {
    name: "Robert Mathis",
    when: "10 months ago",
    text: "Golden State Safety Certifications — A Plus in our books! Troy is respectful, experienced and passionate about PIT and the safety of operators near and far! We will be using you again!",
  },
  {
    name: "Andy Powell",
    when: "1 month ago",
    text: "My instructor came in to my work and gave me an excellent lesson on how to use a forklift and order picker. He taught me a lot of new things I may have never thought of when operating machinery.",
  },
  {
    name: "Stephanie Muniz",
    when: "4 months ago",
    text: "Excellent experience with Golden State Safety. Troy is a top-notch trainer — knowledgeable, patient, and professional. Highly recommend this company for anyone needing forklift certification!",
  },
  {
    name: "Rhonda Williams",
    when: "10 months ago",
    text: "Troy was a really good instructor. Made learning fun and exciting. Now we are ready to train our employees with the information we collected from him. Thanks for traveling to Charleston SC to train us.",
  },
  {
    name: "Gaukhar Tokmagambetova",
    when: "7 months ago",
    text: "We had a great experience. They conducted forklift and aerial lift training for our team, and everything was well organized, efficient, and completed on time with no delays.",
  },
  {
    name: "mark cooper",
    when: "4 weeks ago",
    text: "Amazing owner got back to me quick with all the info I needed. The most professional acting and looking company I could find. Can't wait to start a new chapter in my employment life.",
  },
  {
    name: "Armand Santos",
    when: "1 year ago",
    text: "I highly recommend GSSC. Our company has been using them for the past 3 years. Troy is very professional, knowledgeable and passionate when it comes to forklift safety.",
  },
  {
    name: "Steven Orellana",
    when: "5 months ago",
    text: "If you're looking to get certified and want a smooth and easy process, Golden State Safety is the way to go. Troy was very professional and personable, making the experience more enjoyable.",
  },
  {
    name: "Yajun Zou",
    when: "2 weeks ago",
    text: "Just finished the Train-the-Trainer program. Troy came to the warehouse on time, made the class fun and engaged. Definitely recommend!",
  },
  {
    name: "nv Benjamenz",
    when: "1 year ago",
    text: "Highly recommended! Spanish spoken! Continue applying all safety practices — great Train-the-Trainer program.",
  },
];

export const GALLERY = [
  { src: "/gallery/g7.jpg" },
  { src: "/gallery/g5.jpg" },
  { src: "/gallery/g6.jpg" },
  { src: "/gallery/g10.jpg" },
  { src: "/gallery/g1.jpg" },
  { src: "/gallery/g8.jpg" },
  { src: "/gallery/g3.jpg" },
  { src: "/gallery/g9.jpg" },
  { src: "/gallery/g2.jpg" },
  { src: "/gallery/g4.jpg" },
];

export const COURSE_OPTIONS = [
  "Forklift Certification",
  "Aerial / Scissor Lift",
  "Combo (Forklift + Aerial)",
  "Train-the-Trainer",
];
